import { SpeakingEditComponent } from './edit/speaking-edit.component';
import { SpeakingPreviewComponent } from './preview/speaking-preview.component';
import { SpeakingAnswerComponent } from './answer/speaking-answer.component';
import { SpeakingGradingComponent } from './grading/speaking-grading.component';
import { SpeakingReportComponent } from './report/speaking-report.component';
export var SPEAKING_REGISTRY = {
  edit: SpeakingEditComponent,
  preview: SpeakingPreviewComponent,
  grading: SpeakingGradingComponent,
  answer: SpeakingAnswerComponent,
  report: SpeakingReportComponent
};